import { TableProps } from "@/ui/tables/Table";
import { Button } from "@chakra-ui/react";
import TruncateText from "@/utils/TruncateText";
import { ClientEntity } from "./types/ClientEntity";

export const ClientEntitiesTableColumns = (
  handleToggleEnabled: (clientEntity: ClientEntity) => void,
): TableProps<ClientEntity>["headers"] => {
  return [
    {
      label: "Nombre",
      itemLabel: (item: ClientEntity) => (
        <TruncateText maxWidth={200}>{item.name}</TruncateText>
      ),
      sortable: true,
      sortKey: "name",
    },
    {
      label: "Descripción",
      itemLabel: (item: ClientEntity) => (
        <TruncateText maxWidth={300}>{item.description}</TruncateText>
      ),
      sortable: true,
      sortKey: "description",
    },
    {
      label: "Estado",
      itemLabel: (item: ClientEntity) => (
        <Button
          variant="ghost"
          size="sm"
          colorPalette={item.enabled ? "gray" : "green"}
          color={item.enabled ? "fg.muted" : undefined}
          onClick={() => handleToggleEnabled(item)}
          disabled={item.zones.length > 1}
        >
          {item.enabled ? "Deshabilitar" : "Habilitar"}
        </Button>
      ),
    },
  ];
};
